"use client";

import { FC, useMemo } from "react";

import classNames from "classnames";

import { Container } from "components/organisms/Container/Container";
import { Grid } from "components/organisms/Grid/Grid";
import { Person } from "components/molecules/Person/Person";
import { Pretitle } from "components/atoms/Pretitle/Pretitle";

import { PeopleSectionRecord } from "@graphql/types/graphql";
import s from "./PeopleSection.module.scss";

type Props = {
  data: PeopleSectionRecord;
};

export const PeopleSection: FC<Props> = ({ data: { title, people, layout } }) => {
  const content = useMemo(() => {
    if (layout === "circle") {
      return (
        <div className={s.People}>
          {people.map((person) => (
            <Person {...person} layout={layout} key={person.id} />
          ))}
        </div>
      );
    }
    return (
      <Grid columns="3">
        {people.map((person) => (
          <Person {...person} layout={layout} key={person.id} />
        ))}
      </Grid>
    );
  }, [layout, people]);

  return (
    <Container size="m">
      <div
        className={classNames(s.PeopleSection, {
          [s.IsCentered]: layout === "circle",
        })}
      >
        <Pretitle title={title ?? ""} />
        {content}
      </div>
    </Container>
  );
};
